export enum FitCcLocationFieldLabels {
    LONGITUDE_LABEL = 'Longitude',
    LATITUDE_LABEL = 'Latitude'
}